export function isLocationMatchingSearch(
  location: {
    countryName?: string;
    city?: string;
    countryNameAltLang?: string;
    cityAltLang?: string;
  },
  search?: string,
): boolean {
  if (!search) return true;
  const lowerSearch = search.toLowerCase();
  return (
    location.countryName?.toLowerCase().includes(lowerSearch) ||
    location.city?.toLowerCase().includes(lowerSearch) ||
    location.countryNameAltLang?.toLowerCase().includes(lowerSearch) ||
    location.cityAltLang?.toLowerCase().includes(lowerSearch)
  );
}
